import { ProjectPalette } from 'app/theme';
import { css } from 'styled-components/macro';

export const footerCss = css`
  height: 400px;
  padding-top: 4rem;
  position: relative;
  padding-bottom: 4rem;
  color: ${ProjectPalette.common.white};
  background: ${ProjectPalette.primary.main};

  a {
    color: #fff;
  }

  @media (max-width: 1024px) {
    padding: 1rem;
    padding-top: 3rem;
  }

  @media (max-width: 962px) {
    height: 511px;
  }

  @media (max-width: 768px) {
    height: fit-content;
  }
`;

export const footerAddressCss = css`
  h5 {
    margin: 0;
    margin-bottom: 1rem;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const appbarlinkcss = (active: boolean) => css`
  display: block;
  text-decoration: none;
  font-weight: ${active ? 600 : 400};
  transition: all 0.3s;
  color: ${ProjectPalette.common.white};
  margin-right: 3rem;

  &:hover {
    text-decoration: underline;
  }
`;

export const footerCopyrightCss = css`
  display: flex;
  font-size: 12px;
  position: relative;
  flex-direction: row;
  align-items: baseline;

  a {
    color: #fff;
    cursor: pointer;
    text-decoration: underline;
  }

  .privacy-link {
    margin-right: 12px;
    text-decoration: none;
  }
`;

export const subscribeFormCss = css`
  h5 {
    margin: 0;
    margin-bottom: 1rem;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }

  h6 {
    margin-top: 1rem;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
  }

  input {
    border: 1px solid ${ProjectPalette.common.white};
    width: 217px;
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    color: ${ProjectPalette.common.white};
    background-color: transparent;
    height: 30px;
    padding-left: 1rem;
    outline: none;
    &::placeholder {
      color: ${ProjectPalette.common.white};
    }
    @media (max-width: 1024px) {
      width: 9rem;
    }
    @media (max-width: 768px) {
      width: 217px;
    }
  }

  button {
    border: none;
    height: 30px;
    width: 131px;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
    color: ${ProjectPalette.primary.main};
    background-color: ${ProjectPalette.common.white};
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
`;
